import { getCall, putCall } from "../utils/calls";
import {
  dispatchErrorMessage,
} from "../utils/toast";

export const getSystemAlerts = async (viewLastDays) => {
  const res = await getCall(`/system/alerts?days_limit=${viewLastDays ? viewLastDays : ""}`);
  if (res[0]) {
    return res[0].alerts;
  } else return null;
};

export const getSystemAlertsChannels = async () => {
  const botId = localStorage.getItem("bot");
  const res = await getCall(`/system/alerts/channels/${botId}`);
  if (res[0]) {
    return res[0].alerts; // [{channel: 'whatsapp', alerts: [{ id: 1, description: "Error metodo de pago." }]}, ...]
  } else return null;
};

export const MarkAsResolved = async (data) => {
  const res = await putCall("/system/alerts/" + data.id);
  if (res[0]) {
    return res[0].alert;
  } else {
    dispatchErrorMessage(null, res, "Error al actualizar el estado de la alerta.");
    return null;
  };
};